const isFieldChat = (topic) => !!topic?.fieldName;

const isDocumentChat = (topic) => !!topic?.document?.id;

const isFundChat = (topic) =>
  !!topic?.fundId &&
  !topic?.fieldName &&
  !topic?.document &&
  topic?.chatType === 'FUND';

const isTopLevelChat = (topic) =>
  !topic?.fieldName && !topic?.document && topic?.chatType === 'TOP_LEVEL';

const ChatTopicType = Object.freeze({
  FIELD: 'FIELD',
  DOCUMENT: 'DOCUMENT',
  FUND: 'FUND',
  TOP_LEVEL: 'TOP_LEVEL',
});

export {
  isFieldChat,
  isDocumentChat,
  isFundChat,
  isTopLevelChat,
  ChatTopicType,
};
